import React from 'react';
import PropTypes from 'prop-types';
import * as StyledApplicationFormHeader from './applicationFormHeader.styles';

const levels = [
	{ id: 1, text: '1. Skilmálar' },
	{ id: 2, text: '2. Fylla út umsókn' },
	{ id: 3, text: '3. Staðfesting' },
];

const LAST_LEVEL = 3;

const ApplicationFormHeader = ({
	currentLevel,
	setLevel
}) => {
	const onLevelClick = (level) => {
		if(level < currentLevel) setLevel(level);
	};

	return (
		<StyledApplicationFormHeader.Wrapper>
			{
				levels.map(level => (
					<StyledApplicationFormHeader.Level
						key={level.id}
						active={currentLevel === level.id}
						completed={currentLevel > level.id || currentLevel === LAST_LEVEL}
						disabled={currentLevel < level.id || currentLevel === LAST_LEVEL}
						onClick={onLevelClick.bind(null, level.id)}>
						<StyledApplicationFormHeader.LevelText>
							{level.text}
						</StyledApplicationFormHeader.LevelText>
						<StyledApplicationFormHeader.LevelLineWrapper>
							<StyledApplicationFormHeader.LevelLine />
							<StyledApplicationFormHeader.LevelLineIcon />
						</StyledApplicationFormHeader.LevelLineWrapper>
					</StyledApplicationFormHeader.Level>
				))
			}
		</StyledApplicationFormHeader.Wrapper>
	);
};

ApplicationFormHeader.propTypes = {
	currentLevel: PropTypes.number.isRequired,
	setLevel: PropTypes.func.isRequired
};

export default ApplicationFormHeader;
